
import React from 'react'
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import MediaInfoComponent from '../../../../../common/components/common/media-info.component';



export default function HelpTopicBasicInfoComponent ({helpTopics,mediaFiles,handleFormItemChange,changeImage,handleInnerFormChange, selectedHelpTopics}: any) {
  const libraryData = useSelector(selectListItems)

   return (
    <>
     <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
            label="Title"
            labelField="Title"
            onValueChange={(event: any, newValue: any) => {
              handleInnerFormChange(
                event.target.value,
                'Title'
              );
            }}
            type="text"
            value={selectedHelpTopics?.Title}
        />
      <InputContainer
     label="Parent Topic" 
                      labelField="Title"
                      list={helpTopics}
                      onValueChange={( event: any) => {
                        handleInnerFormChange(
                          event.target.value,
                          'ParentId'
                        );
                      }}
                        optionName="Choose Parent Topic"
                      type="select"
                      valueField="Id"
                      value={selectedHelpTopics?.ParentId}
  />        
        <div className='col-span-full'>
        <InputContainer 
          label="Body"
          name="Body"
          onValueChange={(event: any) => {
            handleInnerFormChange(
              event,
              'Body'
            )
          }}
          type="rte"
          value={selectedHelpTopics?.Body}
      /></div>
     </div>
  }
    expandedPanel="BasicInfo"
    headerTitle="Basic Info"
/>
<AccordionContainer
    child={
          <div>
   <MediaInfoComponent
      changeImage={changeImage}
      fileTypes={libraryData?.result?.FileType}
      onFormItemChange={handleFormItemChange}
      mediaFiles={mediaFiles}
      />
</div>
  }
    expandedPanel="Help topic Media"
    headerTitle="Help Topic Media Info"
/>
</>
  )
}